import { Injectable, resource, inject, computed } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { RouteData } from '../../types/route.type';
import { SemesterService } from '../../../pages/semester/services/semester.service';
import { ProfileService } from './profile.service';

@Injectable({
  providedIn: 'root',
})
export class AppService {
  private profileService = inject(ProfileService);
  private semesterService = inject(SemesterService);

  routeData$ = new BehaviorSubject<RouteData | null>(null);

  currentSemester = resource({
    params: () => ({
      isLoggedIn: this.profileService.loggedIn(),
    }),
    loader: ({ params }) => {
      if (!params.isLoggedIn) {
        return Promise.resolve(undefined);
      }
      return firstValueFrom(this.semesterService.current());
    },
  });
  currentSemesterSafeValue = computed(() =>
    this.currentSemester.hasValue() ? this.currentSemester.value() : undefined,
  );
}
